document.addEventListener('DOMContentLoaded', () => {
  const input = document.querySelector('.searchKits');

  if (input) {
    input.addEventListener('input', (e) => {
      e.preventDefault();

      const targets = document.querySelectorAll('.account-kit__builds-item');

      if (!input.value.length) {
        targets.forEach((item) => {
          item.classList.remove('hide');
        });

        return;
      }

      targets.forEach((item) => {
        const title = item.querySelector('h4');

        if (title.textContent.toLowerCase().includes(input.value)) {
          item.classList.remove('hide');
        } else {
          item.classList.add('hide');
        }
      });
    });
  }
});
